export const moduleConfig = {
    entityKey: 'productLineItems',
    titles: {
        singular: 'Product Line Item',
        plural: 'Product Line Items'
    }
}
